import React from "react"
import { Container, Row, Col } from "@bootstrap-styled/v4"
import { StaticQuery, graphql } from "gatsby"
import { Element } from "react-scroll"
import WOW from "react-wow"
import {
  PersonSupport,
  Star,
  PeopleTeam,
  Heart,
} from "@styled-icons/fluentui-system-regular"
import { Paint, Infinite } from "@styled-icons/boxicons-regular"

import * as S from "./styled"

const BannerBenefits = () => {
  return (
    <StaticQuery
      query={graphql`
        query {
          mobileHero: file(relativePath: { eq: "trumps/mobile-hero.png" }) {
            childImageSharp {
              fluid(maxWidth: 1400) {
                ...GatsbyImageSharpFluid
              }
            }
          }

          content: allMarkdownRemark(
            filter: { fileAbsolutePath: { regex: "/(section_detalhes)/" } }
          ) {
            nodes {
              frontmatter {
                title
                title2
                subtitle
                description
              }
            }
          }
        }
      `}
      render={data => (
        <Element name="section-BannerBenefits">
          <S.BannerBenefitsWrapper>
            <S.BannerBenefitsContent>
              <Container>
                <Row>
                  <WOW animation="fadeIn">
                    <Col
                      xs={{
                        order: 2,
                        size: 12,
                      }}
                    >
                      <S.BannerBenefitsCaption>
                        <WOW animation="fadeInUp">
                          <S.BannerBenefitsSubTitle>
                            Na gente, você pode confiar.🤍
                          </S.BannerBenefitsSubTitle>
                          <S.BannerBenefitsTitle>
                            Beneficios <span>em ter um projeto Evolve:</span>
                          </S.BannerBenefitsTitle>
                          <S.BannerBenefitsDesc></S.BannerBenefitsDesc>
                        </WOW>
                      </S.BannerBenefitsCaption>
                    </Col>
                  </WOW>
                </Row>

                <Row>
                  <Col
                    xs={{
                      size: 12,
                    }}
                    lg={{
                      size: 4,
                    }}
                  >
                    <S.BannerBenefitsItem>
                      <WOW animation="fadeInUp">
                        <S.BannerBenefitsItemIcon>
                          <PersonSupport />
                        </S.BannerBenefitsItemIcon>
                        <S.BannerBenefitsItemTitle>
                          Suporte 24h/7d <br />
                          para clientes
                        </S.BannerBenefitsItemTitle>
                        <S.BannerBenefitsItemDesc>
                          Estamos disponíves a qualquer horário do dia, em
                          qualquer dia da semana, para auxiliar em qualquer caso
                          de problemas ou urgências que possam surgir. Você pode
                          contar com um suporte especializado sempre que
                          precisar.
                        </S.BannerBenefitsItemDesc>
                      </WOW>
                    </S.BannerBenefitsItem>
                  </Col>

                  <Col
                    xs={{
                      size: 12,
                    }}
                    lg={{
                      size: 4,
                    }}
                  >
                    <S.BannerBenefitsItem>
                      <WOW animation="fadeInUp">
                        <S.BannerBenefitsItemIcon>
                          <Star />
                        </S.BannerBenefitsItemIcon>
                        <S.BannerBenefitsItemTitle>
                          Tecnologias de
                          <br /> última geração
                        </S.BannerBenefitsItemTitle>
                        <S.BannerBenefitsItemDesc>
                          Utilizamos o que existe de melhor e mais moderno no
                          mercado da tecnologia. Desenvolver com ferramentas
                          atuais significa mais performance, possibilidades,
                          velocidade no desenvolvimento e uma longa vida para a
                          sua aplicação.
                        </S.BannerBenefitsItemDesc>
                      </WOW>
                    </S.BannerBenefitsItem>
                  </Col>

                  <Col
                    xs={{
                      size: 12,
                    }}
                    lg={{
                      size: 4,
                    }}
                  >
                    <S.BannerBenefitsItem>
                      <WOW animation="fadeInUp">
                        <S.BannerBenefitsItemIcon>
                          <PeopleTeam />
                        </S.BannerBenefitsItemIcon>
                        <S.BannerBenefitsItemTitle>
                          Profissionais experientes
                          <br /> e especializados
                        </S.BannerBenefitsItemTitle>
                        <S.BannerBenefitsItemDesc>
                          Nossa equipe é formada por diversos profissionais
                          especializados em áreas como Marketing, Design,
                          Engenharia de Software, Gestão de Projetos, por
                          diante, com anos de experiência no que fazem.
                          Escolhemos os melhores para montar a melhor equipe.
                        </S.BannerBenefitsItemDesc>
                      </WOW>
                    </S.BannerBenefitsItem>
                  </Col>

                  <Col
                    xs={{
                      size: 12,
                    }}
                    lg={{
                      size: 4,
                    }}
                  >
                    <S.BannerBenefitsItem>
                      <WOW animation="fadeInUp">
                        <S.BannerBenefitsItemIcon>
                          <Paint />
                        </S.BannerBenefitsItemIcon>
                        <S.BannerBenefitsItemTitle>
                          Design 100% exclusivo
                        </S.BannerBenefitsItemTitle>
                        <S.BannerBenefitsItemDesc>
                          Nós desenvolvemos experiências que sejam totalmente
                          exclusivas e feitas para expressar com autenticidade a
                          essência do seu negócio. Não basta copiar e editar
                          algo que já está pronto, a sua presença digital
                          precisa ser autêntica e expressar a alma da sua marca.
                        </S.BannerBenefitsItemDesc>
                      </WOW>
                    </S.BannerBenefitsItem>
                  </Col>

                  <Col
                    xs={{
                      size: 12,
                    }}
                    lg={{
                      size: 4,
                    }}
                  >
                    <S.BannerBenefitsItem>
                      <WOW animation="fadeInUp">
                        <S.BannerBenefitsItemIcon>
                          <Heart />
                        </S.BannerBenefitsItemIcon>
                        <S.BannerBenefitsItemTitle>
                          Contato atencioso e com aquele carinho
                        </S.BannerBenefitsItemTitle>
                        <S.BannerBenefitsItemDesc>
                          Entendemos o quanto é importante ser bem tratado e
                          valorizado, ainda mais em algo que é importante para a
                          gente. Um de nossos pilares é o respeito e uma atenção
                          do {`<3`} com todos os nossos clientes.
                        </S.BannerBenefitsItemDesc>
                      </WOW>
                    </S.BannerBenefitsItem>
                  </Col>

                  <Col
                    xs={{
                      size: 12,
                    }}
                    lg={{
                      size: 4,
                    }}
                  >
                    <S.BannerBenefitsItem>
                      <WOW animation="fadeInUp">
                        <S.BannerBenefitsItemIcon>
                          <Infinite />
                        </S.BannerBenefitsItemIcon>
                        <S.BannerBenefitsItemTitle>
                          Tudo o que você precisa, em um lugar só
                        </S.BannerBenefitsItemTitle>
                        <S.BannerBenefitsItemDesc>
                          Nossos serviços são completos e abrangem uma rica gama
                          de possibilidades. Chama já a gente e bora bater um
                          papo sem compromisso sobre as suas necessidades e como
                          podemos resolvê-las da melhor forma possível!
                        </S.BannerBenefitsItemDesc>
                      </WOW>
                    </S.BannerBenefitsItem>
                  </Col>
                </Row>
              </Container>
            </S.BannerBenefitsContent>
          </S.BannerBenefitsWrapper>
        </Element>
      )}
    />
  )
}

export default BannerBenefits
